import Vue from 'vue'
import Vuex from 'vuex'
import auth from './modules/auth'
import register from './modules/register'
import user from './modules/user'
import profile from './modules/profile'
import app from './modules/app'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    app,
    auth,
    register,
    user,
    profile
  }
})
